





import { Vue, Prop, Watch, Component } from "vue-property-decorator";

@Component( {
    name: "Main",
    props: {},
    components: {}
} )
export default class Main extends Vue {

    constructor() {
        super();
    }

    public mounted() {

        this.$EventBus.$on( 'scroll-bottom', (x: 'auto' | 'smooth') => {
            document.documentElement.scrollTo( {
                left: 0,
                top: document.documentElement.scrollHeight - document.documentElement.clientHeight,
                behavior: x
            } );
        } );

        let self = this;
        window.addEventListener( 'keyup', ( e: any ) => { self.$EventBus.Teclas( e ); } );
        window.document.body.onscroll = function ( Event: any ) { self.$EventBus.Scroll( Event ); };


    }
}
